import {borderRadius} from './borderRadius'
import {color} from './color'
import {font} from './font'
import {fontWeight} from './fontWeight'
import {lineHeight} from './lineHeight'
import {size} from './size'
import {transition} from './transition'
import {typographyScale} from './typographyScale'
import {unit} from './unit'

export const styles = {
    borderRadius,
    color,
    font,
    fontWeight,
    lineHeight,
    size,
    transition,
    typographyScale,
    unit
}